// This file is the main entry point for the application.
// It wraps the entire application in the necessary context providers and routers.

import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { SidebarProvider } from "./components/ui/sidebar";
import PageRoutes from "./pages/routes";
import { ThemeProvider } from "./lib/theme_context";
import { AlertProvider } from "./components/Page/alert_context";
import AlertComponent from "./components/Unique/Misc/alert_component";
import "bootstrap/dist/css/bootstrap.min.css";
import StatisticsContextProvider from "./components/Statistics/statistics_context";
import AdministrationContextProvider from "./components/Administration/administration_context";
import { NonogramProvider } from "./components/Unique/Nonogram/Generator From Image/nonogram_context";
import { TilesProvider } from "./components/Unique/Tiles/tiles_context";
import Sidebarnav from "./components/Sidebar/sidebarnav";
const App = () => {
  return (
    <AlertProvider>
      <ThemeProvider>
        <SidebarProvider>
          <NonogramProvider>
            <TilesProvider>
              <AdministrationContextProvider>
                <StatisticsContextProvider>
                  <Router>
                    <Sidebarnav />
                    <PageRoutes />
                    <AlertComponent />
                  </Router>
                  {/*<div className="footer">*/}
                  {/*    ©Copyright Denda Games 2024*/}
                  {/*</div>*/}
                </StatisticsContextProvider>
              </AdministrationContextProvider>
            </TilesProvider>
          </NonogramProvider>
        </SidebarProvider>
      </ThemeProvider>
    </AlertProvider>
  );
};

export default App;
